export default __webpack_public_path__ + "static/media/pantry2-after2-1440w.0144f9c7.png";